import React, { useEffect, useState } from 'react';
import { Card, CardHeader, CardContent } from './ui/card';
import StatCard from './StatCard';

const LearnignStats = () => {
  const [reviewCount, setReviewCount] = useState(0);
  const [numDistinctReviewExamples, setNumDistinctReviewExamples] = useState(0);

  useEffect(() => {
    async function getStats() {
      const res = await fetch(`/api/get-user-stats`);

      if (!res.ok) {
        console.log(res.statusText);
        return;
      }
      const { reviewCount, numDistinctReviewExamples } = await res.json();

      setReviewCount(reviewCount);
      setNumDistinctReviewExamples(numDistinctReviewExamples);
    }
    getStats();
  }, []);

  return (
    <Card className="h-auto w-full">
      <CardHeader>
        <h2 className="h2 flex items-center gap-2 pb-0!">
          <span>Proactivity</span>
        </h2>
      </CardHeader>
      <CardContent>
        <StatCard
          text={`You have reviewed ${reviewCount} cards`}
          variant="info"
        />
        <StatCard
          text={`You have reviewed ${numDistinctReviewExamples} different commands`}
          variant="info"
        />
      </CardContent>
    </Card>
  );
};

export default LearnignStats;
